import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText, FDHeadlineText,
} from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly);
